<template>
    <ul class="koolitused-list">
        <li v-for="koolitus in koolitused" :key="koolitus.id">
            <div class="koolitus-header">
                <div class="calendar">
                    <div class="day">{{koolitus.day}}</div>
                    <div class="month">{{koolitus.month}}</div>
                </div>
                <div class="content">
                    <h2>{{koolitus.trainingName}}</h2>
                    <div class="content-footer">
                        <label class="free" v-if="koolitus.price == 0">Tasuta</label>
                        <button class="read-more" v-show="koolitus.id !== active" @click="onClick(koolitus)">Vaata lähemalt</button>
                        <button class="close-more" v-show="koolitus.id == active" @click="close()">Sulge</button>
                    </div>
                </div>
            </div>
            <div class="koolitus-content" v-show="koolitus.id == active">
                <div class="koolitus-content-row">
                    <div class="description" v-html="koolitus.description"></div>
                    <div class="qr">
                        <div v-html="koolitus.qr"></div>
                        <label>Loe edasi</label>
                    </div>
                </div>
                <ul class="contacts">
                    <li class="email"><icon name="envelope" /> <label>koolitused@hkhk.edu.ee</label></li>
                    <li class="phone"><icon name="phone" /> <label>{{koolitus.phone}}</label></li>
                    <li class="address"><icon name="pin" /> <label>{{koolitus.address}}</label></li>
                </ul>
            </div>
        </li>
        <li v-show="koolitused.length == 0" class="loading">Laeb...</li>
    </ul>
</template>

<script>
export default {
    data () {
        return {
            koolitused: [],
            active: 0,
            months: ["jaanuar", "veebruar", "märts", "aprill", "mai", "juuni", "juuli", "august", "september", "oktoober", "november", "detsember"]
        }
    },
    async mounted ()  {
        const url = 'https://mirror.3dwayfinder.com/https://koolitus.edu.ee/api/trainings'
        const response = await fetch(url, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer h4sq2yk8cy71raq867z7h'
            },
        });
        const now = Date.now();
        const QRCode = require("qrcode-svg");
        let _koolitused = await response.json();
        
        _koolitused = _koolitused.filter(k => {
            if (k.endingDate && Date.parse(k.endingDate) > now && !(k.status == "A" || k.status == "D" || k.status == "F")) {
                return true;
            }
            else {
                return false;
            }
        }).map(k => {
            let startingDate = new Date(k.startingDate);
            let endingDate = new Date(k.endingDate);
            let qr = null;
            if (QRCode && k.publicUrl) {
				qr = new QRCode({content: k.publicUrl, container: "svg-viewbox", padding: 0}).svg();
			}
            return {
                trainingName: k.courseDescription.trainingName,
                day: startingDate == endingDate ? startingDate.getDate().toString().padStart(2, '0') : startingDate.getDate().toString().padStart(2, '0')  + " - " + endingDate.getDate().toString().padStart(2, '0'),
                month: startingDate == endingDate ? this.months[startingDate.getMonth()] : this.months[startingDate.getMonth()] + " - " + this.months[endingDate.getMonth()],
                price: k.price,
                id: k.id,
                description: k.courseDescription.description,
                email: k.projectManager ? k.projectManager.email : "koolitused@hkhk.edu.ee",
                phone: k.projectManager ? k.projectManager.phone : "",
                address: k.venueAddress + ", "+ k.venueCity,
                qr: qr
            }
        });
        this.koolitused = _koolitused;
    },
    computed: {
        date () {
            var d = new Date();
            return d.getDate() + ". " + this.months[d.getMonth()];
        }
    },
    methods: {
        onClick (koolitus) {
            this.active = koolitus.id;
        },
        close () {
            this.active = 0;
        }
    }
}
</script>

<style lang="less" scoped>
    @import '../theme/variables';

    .koolitused {
        h1 {
            margin-bottom: 0;
        }
        ul {
            list-style-type: none;
            padding: 0;
        }

        li {
            margin: 3rem 0rem;
            padding-bottom: 2rem;
            border-bottom: 1px solid @medium-background;

            &.loading {
                text-align: center;
                margin: 10rem 0rem;
                border-bottom: 0;
            }

            .koolitus-header {
                display: flex;
                flex-direction: row;
                width: 100%;
                padding-right: 4rem;
            }

            .koolitus-content {
                padding: 2rem 0;
            }

            .koolitus-content-row {
                display: flex;
                flex-direction: row;
                width: 100%;
                justify-content: space-between;
            }

            h2 {
                color: @action-color;
                margin-top: 0;
            }

            .free {
                background: @medium-background;
                border-radius: 2rem;
                padding: 0 1em;
                line-height: 2.2;
            }

            .content-footer {
                display: flex;
                justify-content: space-between;
            }

            .content {
                flex-shrink: 0;
                flex-grow: 1;
                width: min-content;
            }

            .read-more, .close-more {
                font-size: 2.5rem;
                border-radius: 2.5rem;
                padding: 0.5rem 2rem;
                line-height: 1.3;
            }

            .qr {
                height: 20rem;
                width: 20rem;
                margin-right: 4rem;
                padding-left: 1rem;
                display: flex;
                flex-direction: column;
                align-items: center;

                div {
                    width: 100%;
                }
            }

            .contacts {
                margin-left: 2rem;
                margin-top: 2rem;
                .icon {
                    height: 2rem;
                    margin-right: 1rem;
                    padding-top: 0.2em;
                }
                li {
                    margin-bottom: 0;
                    margin-top: 1rem;
                    padding-bottom: 0;
                    border-bottom: 0;

                    &.email label {
                        color: @action-color;
                    }
                }
            }
        }
    }
    .calendar {
        width: 15rem;
        margin-right: 2rem;
        text-align: center;
        flex-shrink: 0;
        position: relative;

        &:after, &:before {
            content: " ";
            display: block;
            width: 1rem;
            height: 2.5rem;
            border-radius: 0.5rem;
            background: #BDBDBD;
            overflow: hidden;
            position: absolute;
            top: -1.25rem;
            left: 50%;
        }

        &:before {
            margin-left: -2rem;
        }

        &:after {
            margin-left: 2rem;
        }

        .day {
            background: @action-color;
            border-radius: 1rem 1rem 0 0;
            color: @action-font-color;
            height: 10rem;
            line-height: 11rem;
            font-size: 3.5rem;
        }

        .month {
            background: @medium-background;
            border-radius: 0 0 1rem 1rem;
            color: @font-color-light;
            height: 4rem;
            line-height: 4.1rem;
            font-size: 1.6rem;
        }
    }
</style>